@if (!planningItems || planningItems.length === 0) {
  <div class="planning-empty">
    <i class="material-icons">event_busy</i>
    <p>No upcoming events</p>
  </div>
}

@if (planningItems && planningItems.length > 0) {

  <!-- CARROUSEL -->
  <div class="planning-carousel">
    <button class="carousel-btn" (click)="prevEvent()" [disabled]="currentIndex === 0">
      <i class="material-icons">chevron_left</i>
    </button>
    <div class="carousel-card" [ngClass]="'background-color-' + currentEvent.event.eventType.toLowerCase()">
      <div class="carousel-icon" [ngClass]="'event-icon-' + currentEvent.event.eventType.toLowerCase()"></div>
      <div class="carousel-desc">{{ currentEvent.event.eventDesc }}</div>
    </div>
    <button class="carousel-btn" (click)="nextEvent()" [disabled]="currentIndex === planningItems.length - 1">
      <i class="material-icons">chevron_right</i>
    </button>
  </div>

  @if (planningItems.length > 1) {
    <div class="carousel-dots">
      @for (item of planningItems; track item; let i = $index) {
        <span class="carousel-dot" [class.active]="i === currentIndex" (click)="goToEvent(i)"></span>
      }
    </div>
  }

  <!-- INFOS -->
  <div class="planning-info">
    <div class="planning-info-item">
      <i class="material-icons planning-info-icon">date_range</i>
      <div>
        <div class="planning-info-label">Date</div>
        @if (currentEvent.event.eventStartDate === currentEvent.event.eventEndDate) {
          <div>
            {{ currentEvent.event.eventStartDate | date:'EEE d MMMM y' }}
            <span class="time-badge">
              {{ currentEvent.event.eventStartPeriod === 'AM' ? 'Morning' : currentEvent.event.eventStartPeriod === 'PM' ? 'Afternoon' : 'Afterwork' }}
            </span>
          </div>
        } @else {
          <div>
            {{ currentEvent.event.eventStartDate | date:'d MMM y' }}
            <span class="time-badge">{{ currentEvent.event.eventStartPeriod }}</span>
            &nbsp;→&nbsp;
            {{ currentEvent.event.eventEndDate | date:'d MMM y' }}
            <span class="time-badge">{{ currentEvent.event.eventEndPeriod }}</span>
          </div>
        }
      </div>
    </div>

    @if (currentEvent.event.additionalDesc) {
      <div class="planning-info-item">
        <i class="material-icons planning-info-icon">comment</i>
        <div>
          <div class="planning-info-label">Description</div>
          <div [innerHTML]="currentEvent.event.additionalDesc"></div>
        </div>
      </div>
    }

    @if (currentEvent.event.eventLocation) {
      <div class="planning-info-item">
        <i class="material-icons planning-info-icon">location_on</i>
        <div>
          <div class="planning-info-label">Location</div>
          <div>{{ currentEvent.event.eventLocation }}</div>
        </div>
      </div>
    }

    <div class="planning-info-item">
      <i class="material-icons planning-info-icon">info</i>
      <div>
        <div class="planning-info-label">Status</div>
        <div [ngClass]="getStatusClass(currentEvent.event.eventStatus)"><strong>{{ currentEvent.event.eventStatus }}</strong></div>
      </div>
    </div>
  </div>

  <!-- ACTIONS -->
  @if (!isEventManager() && currentEvent.event.invitationStatus !== 'MANDATORY') {
    <div class="planning-actions">
      @if (currentEvent.event.invitationStatus === 'ACCEPTED') {
        <p class="planning-status-msg accepted"><i class="material-icons">check_circle</i> You accepted this event</p>
      }
      @if (currentEvent.event.invitationStatus === 'PENDING') {
        <p class="planning-status-msg pending"><i class="material-icons">help</i> Will you attend this event?</p>
      }
      @if (currentEvent.event.invitationStatus === 'REFUSED') {
        <p class="planning-status-msg refused"><i class="material-icons">cancel</i> You declined this event</p>
      }
      <div class="planning-actions-btns">
        @if (currentEvent.event.invitationStatus !== 'ACCEPTED') {
          <button class="btn-participate accept" (click)="handleParticipationResponse(currentEvent.event, true)">
            <i class="material-icons">check_circle</i> I'll attend
          </button>
        }
        @if (currentEvent.event.invitationStatus !== 'REFUSED') {
          <button class="btn-participate decline" (click)="handleParticipationResponse(currentEvent.event, false)">
            <i class="material-icons">cancel</i> I decline
          </button>
        }
      </div>
    </div>
  }

  <!-- PARTICIPANTS -->
  <div class="planning-participants">
    <div class="planning-section-title">Attendees</div>
    <div class="planning-participants-grid">

      <div class="participants-col accepted">
        <div class="participants-col-header">
          <i class="material-icons">check_circle</i>
          <span>Attending ({{ currentEvent.agreeList?.length ?? 0 }})</span>
        </div>
        @for (user of currentEvent.agreeList; track user) {
          <div class="participant-item">{{ user.userFirstName }} {{ user.userName }}</div>
        }
        @if (!currentEvent.agreeList?.length) {
          <div class="participant-empty">None</div>
        }
      </div>

      <div class="participants-col declined">
        <div class="participants-col-header">
          <i class="material-icons">cancel</i>
          <span>Declined ({{ currentEvent.refuseList?.length ?? 0 }})</span>
        </div>
        @for (user of currentEvent.refuseList; track user) {
          <div class="participant-item">{{ user.userFirstName }} {{ user.userName }}</div>
        }
        @if (!currentEvent.refuseList?.length) {
          <div class="participant-empty">None</div>
        }
      </div>

      <div class="participants-col pending">
        <div class="participants-col-header">
          <i class="material-icons">help</i>
          <span>Pending ({{ currentEvent.pendingList?.length ?? 0 }})</span>
        </div>
        @for (user of currentEvent.pendingList; track user) {
          <div class="participant-item">{{ user.userFirstName }} {{ user.userName }}</div>
        }
        @if (!currentEvent.pendingList?.length) {
          <div class="participant-empty">None</div>
        }
      </div>

    </div>
  </div>

  @if (showAlert) {
    <notification [timeout]="10000" [severity]="notifType" [message]="notifMessage"
      (hideNotification)="showAlert = false"></notification>
  }
}
